export default "__VITE_ASSET__e908d225__"